import React, { useEffect, useRef } from "react";
import "./visual-story-modal.m.css";


const VisualStoryModal = ({ show, onClose, children, closePopup, onNext, onPrevious, currentStoryIndex }) => {
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closePopup();
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      handleClickOutside(event);
    };
    document.addEventListener('click', handleOutsideClick, true);
    return () => {
      document.removeEventListener('click', handleOutsideClick, true);
    };
  }, []);

  if (!show) return null; // Modal doesn't render if show is false

  return (
    <div styleName="modal">
      <div styleName="modal-wrapper" ref={modalRef}>
      <div styleName="modal-content">
        <span styleName="close" onClick={onClose}><i className="ri-close-line"></i></span>
        {children}
      </div>
      <div styleName="button-wrapper">
        {currentStoryIndex > 0 ? (
          <span styleName="previous-button" onClick={onPrevious}>
            <i className="ri-arrow-left-double-line"></i>Edellinen tarina
          </span>
        ) : (
          <span styleName="previous-button" />
        )}
        <span styleName="next-button" onClick={onNext}>Seuraava tarina <i className="ri-arrow-right-double-line"></i></span>
      </div>
    </div>
    </div>
  );
};
export default VisualStoryModal;
